var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'placeholder-rect',
    { '--round': _vm.round, '--full-width': _vm.fullWidth }
  ],style:(_vm.placeholderStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }